import { IObject } from "@quest/base-core";

export let eventDispatchers: IObject = {
  //resize 
  RESIZE_CANVAS_ON_HELP_ZOOM: "RESIZE_CANVAS_ON_HELP_ZOOM",
  RESIZE_SETTING_PANEL: "RESIZE_SETTING_PANEL",
  
  INITIALIZE_FREE_PLAY_ON_GAME: "INITIALIZE_FREE_PLAY_ON_GAME",
  SET_FREEPLAY_VIEW_LAYERING: "SET_FREEPLAY_VIEW_LAYERING",
  //PROGRESS BAR
  START_TO_UPDATE_PROGRESS_BAR: "START_TO_UPDATE_PROGRESS_BAR",
  RESET_PROGRESS_BAR_ELEMENTS: "RESET_PROGRESS_BAR_ELEMENTS",

  RESET_TOGGLE_SOUND_COUNTER: "RESET_TOGGLE_SOUND_COUNTER",
  // TOP LOGO BASE GAME
  TOP_LOGO_HIDE_ON_BIG_WIN:"TOP_LOGO_HIDE_ON_BIG_WIN",
  TOP_LOGO_HIDE_ON_BIG_WIN_FG:"TOP_LOGO_HIDE_ON_BIG_WIN_FG",
  TOP_LOGO_SHOW_ON_BIG_WIN:"TOP_LOGO_SHOW_ON_BIG_WIN",
  TOP_LOGO_SHOW_ON_BIG_WIN_FG:"TOP_LOGO_SHOW_ON_BIG_WIN_FG",
  // GRAND JACKPOT IN FREE GAME
  SHOW_OUTRO_AFTER_FG: "SHOW_OUTRO_AFTER_FG",
  SHOW_POP_UP_BLUR_BG: "SHOW_POP_UP_BLUR_BG",
  HIDE_POP_UP_BLUR_BG: "HIDE_POP_UP_BLUR_BG",
  // RETRIGGER
  START_RETRIGGER_PRESENTATION: "START_RETRIGGER_PRESENTATION",

  UPDATE_JACKPOT_METERS_VALUES: "UPDATE_JACKPOT_METERS_VALUES",
  // SCATTER PRESENTATION
  START_SCATTER_TRIGGRING_ANIMATION: "START_SCATTER_TRIGGRING_ANIMATION",
  START_SCATTER_TRIGGRING_ANIMATION_FG: "START_SCATTER_TRIGGRING_ANIMATION_FG",
  RESET_SCATTER_DATA: "RESET_SCATTER_DATA",
  RESET_SCATTER_DATA_FG: "RESET_SCATTER_DATA_FG",

  AWARD_JACKPOT_FG: "AWARD_JACKPOT_FG",

  //STACK SYMBOL
  INITIALIZE_BASEGAME_STACK_FEATURE: "INITIALIZE_BASEGAME_STACK_FEATURE",
  SHOW_LARGE_STACK_SYMBOL: "SHOW_LARGE_STACK_SYMBOL",
  HIDE_LARGE_STACK_SYMBOL: "HIDE_LARGE_STACK_SYMBOL",
  PLAY_STACK_SYM_ANIM: "PLAY_STACK_SYM_ANIM",
  STOP_STACK_SYM_ANIM: "STOP_STACK_SYM_ANIM",
  INITIALIZE_FREEGAME_STACK_FEATURE: "INITIALIZE_FREEGAME_STACK_FEATURE",
  SHOW_LARGE_STACK_SYMBOL_FG: "SHOW_LARGE_STACK_SYMBOL_FG",
  HIDE_LARGE_STACK_SYMBOL_FG: "HIDE_LARGE_STACK_SYMBOL_FG",
  PLAY_STACK_SYM_ANIM_FG: "PLAY_STACK_SYM_ANIM_FG",
  STOP_STACK_SYM_ANIM_FG: "STOP_STACK_SYM_ANIM_FG",
  STOP_STACK_ANIM_WITH_LINE_WIN: "STOP_STACK_ANIM_WITH_LINE_WIN",

  //MAGIC POTION BASE GAME
  INITIALIZE_MAGIC_POTION_BG: "INITIALIZE_MAGIC_POTION_BG",
  MAGIC_POTION_START: "MAGIC_POTION_START",
  MAGIC_POTION_JACKPOT_CONVERSION: "MAGIC_POTION_JACKPOT_CONVERSION",
  START_POT_WIN_TICKUP: "START_POT_WIN_TICKUP",
  RESET_DATA: "RESET_DATA",
  FS_POT_SYMBOL_CONVERSION: "FS_POT_SYMBOL_CONVERSION",
  HIDE_MAGIC_POTION: "HIDE_MAGIC_POTION",
  SHOW_MAGIC_POTION: "SHOW_MAGIC_POTION",
  HIDE_POTION_LANDING_SYMBOL: "HIDE_POTION_LANDING_SYMBOL",
  FORCE_STOP_POT_CONVERSION: "FORCE_STOP_POT_CONVERSION",
  FORCE_STOP_POT_WIN_METER_TICKUP: "FORCE_STOP_POT_WIN_METER_TICKUP",
  SHOW_JACKPOT_WINBLAST: "SHOW_JACKPOT_WINBLAST",
  SHOW_JACKPOT_WINBLAST_FG: "SHOW_JACKPOT_WINBLAST_FG",

  //MAGIC POTION FREE GAME
  MAGIC_POTION_START_FG: "MAGIC_POTION_START_FG",
  RESET_DATA_FG: "RESET_DATA_FG",
  FS_POT_SYMBOL_CONVERSION_FG: "FS_POT_SYMBOL_CONVERSION_FG",
  SHOW_COIN_PRIZE_FG: "SHOW_COIN_PRIZE_FG",
  HIDE_POTION_LANDING_ANIM_FG: "HIDE_POTION_LANDING_ANIM_FG",
  FORCE_STOP_POT_CONVERSION_FG: "FORCE_STOP_POT_CONVERSION_FG",
  FORCE_STOP_POT_WIN_METER_TICKUP_FG: "FORCE_STOP_POT_WIN_METER_TICKUP_FG",
  UPDATE_CAPSULE_COUNTER_ONSTAGE_CLICK: "UPDATE_CAPSULE_COUNTER_ONSTAGE_CLICK",
  PLAY_CAPSULE_ANIM_ON_FORCESTOP: "PLAY_CAPSULE_ANIM_ON_FORCESTOP",
  HIDE_CAPSULE_ANIM_ON_FORCESTOP: "HIDE_CAPSULE_ANIM_ON_FORCESTOP",

  //JACKPOT BANNER PRESENTATION
  SHOW_JACKPOT_BANNER: "SHOW_JACKPOT_BANNER",
  INITIALIZE_JACKPOT_PRESENTATION: "INITIALIZE_JACKPOT_PRESENTATION",
  START_JP_BUTTON_PANEL_TICKUP: "START_JP_BUTTON_PANEL_TICKUP",

  PLAY_MUSIC_SPIN: "PLAY_MUSIC_SPIN",
  START_JP_BANNER_TICKUP: "START_JP_BANNER_TICKUP",

  //FREEGAME TOP JACKPOT PANEL
  FILL_JACKPOT_CAPSULE: "FILL_JACKPOT_CAPSULE",
  RESET_CAPSULE_FILLED_DATA: "RESET_CAPSULE_FILLED_DATA",
  UPDATE_JACKPOT_COUNTER: "UPDATE_JACKPOT_COUNTER",
  UPDATE_JACKPOT_WIN_PRIZE: "UPDATE_JACKPOT_WIN_PRIZE",

  //REELSET
  UDPATE_NEW_FG_REELSET: "UDPATE_NEW_FG_REELSET",
  UDPATE_NEW_REELSET: "UDPATE_NEW_REELSET",


  //  BLUR BACKGROUND
  SHOW_BIGWIN_BLUR_BG: "SHOW_BIGWIN_BLUR_BG",
  SHOW_FG_INTRO_BLUR_BG: "SHOW_FG_INTRO_BLUR_BG",
  SHOW_FG_OUTRO_BLUR_BG: "SHOW_FG_OUTRO_BLUR_BG",
  SHOW_GRAND_BLUR_BG: "SHOW_GRAND_BLUR_BG",
  SHOW_MAJOR_BLUR_BG: "SHOW_MAJOR_BLUR_BG",
  SHOW_MINOR_BLUR_BG: "SHOW_MINOR_BLUR_BG",
  SHOW_MINI_BLUR_BG: "SHOW_MINI_BLUR_BG",
  SHOW_RETRIGGER_BLUR_BG: "SHOW_RETRIGGER_BLUR_BG",


  HIDE_BIGWIN_BLUR_BG: "HIDE_BIGWIN_BLUR_BG",
  HIDE_FG_INTRO_BLUR_BG: "HIDE_FG_INTRO_BLUR_BG",
  HIDE_FG_OUTRO_BLUR_BG: "HIDE_FG_OUTRO_BLUR_BG",
  HIDE_GRAND_BLUR_BG: "HIDE_GRAND_BLUR_BG",
  HIDE_MAJOR_BLUR_BG: "HIDE_MAJOR_BLUR_BG",
  HIDE_MINOR_BLUR_BG: "HIDE_MINOR_BLUR_BG",
  HIDE_MINI_BLUR_BG: "HIDE_MINI_BLUR_BG",
  HIDE_RETRIGGER_BLUR_BG: "HIDE_RETRIGGER_BLUR_BG",


  SHOW_BLUR_BACKGROUND: "SHOW_BLUR_BACKGROUND",
  HIDE_BLUR_BACKGROUND: "HIDE_BLUR_BACKGROUND",
  // LOGO
  SHOW_BOTTOM_BAR_LOGO: "SHOW_BOTTOM_BAR_LOGO",

  FULL_SCREEN_GAME: "FULL_SCREEN_GAME",
  DISABLE_FULL_SCREEN_GAME: "DISABLE_FULL_SCREEN_GAME",
  SHOW_TOP_BAR: "SHOW_TOP_BAR",
  RESIZE_CANVAS: "RESIZE_CANVAS",
  ADD_TOP_BAR_ON_TOP: "ADD_TOP_BAR_ON_TOP",
};
